import {
  stores,
} from './../mobx-store/index';
import Connections from '../connections';
import {
  AxiosRequestConfig,
} from 'axios';

export const httpUploadFile = (requestPath: string, data: any, config?: AxiosRequestConfig): any => Connections.wadiDeglaAxios.httpPost(requestPath, data, {
  headers: {
    Authorization: `Bearer ${stores.authStore.accessToken}`,
  },
  ...config,
});
